import React from "react";
import ReactGA from "react-ga";
import styles from "./filter-and-search.module.scss";
import { useIsMobile } from "../../hooks/mobile.js";

import FilterDropdown from "../filter-dropdown/filter-dropdown";
import SelectTheme from "../select-theme/select-theme";

ReactGA.initialize("UA-11963560-5");

export default function FilterAndSearch(props) {
    const {
        themes,
        searchOptions,
        handleTopicFilter,
        handleKeywordFilter,
        handleThemeFilter,
        handleSubThemeFilter,
        handleReset,
        handleOpportunitySearch,
        handleOpportunityInput,
        handleOpportunitySearchReset,
        topicFilterState,
        keywordFilterState,
        themeFilterState,
        subThemeFilterState,
        opportunitySearch,
    } = props;

    const [expanded, setExpanded] = React.useState(false);
    const isMobile = useIsMobile();
    const filterRef = React.useRef();

    const handleKeyDown = event => {
        if (event.key === "Enter") {
            handleOpportunitySearch(event);
        }
    };
    const handleInputChange = event => {
        handleOpportunityInput(event);
    };
    const handleExpanded = () => {
        setExpanded(!expanded);
        ReactGA.event({
            category: "SCIKNOW: filter and search",
            action: "expand",
            label: expanded ? "false" : "true",
        });
    };
    const handleApply = () => {
        // close and scroll to top of filter
        setExpanded(false);
        filterRef.current.scrollIntoView();
        ReactGA.event({
            category: "SCIKNOW: filter and search",
            action: "apply",
        });
    };

    return (
        <div className={styles.filterAndSearch} ref={filterRef}>
            {!isMobile && (
                <div className={styles.filterHeader}>
                    <h3>Filter and search</h3>
                    <button className={styles.filtersReset} onClick={() => handleReset()}>
                        Reset filters and search
                    </button>
                </div>
            )}
            {isMobile && (
                <div className={styles.filterHeaderExpando} onClick={() => handleExpanded()}>
                    <h3>Filter and search</h3>
                    <div className={styles.filterShowHide}>
                        <span className={styles.filterShowHideLabel}>{expanded ? "Hide" : "Show"}</span>
                        {expanded && (
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"
                                ></path>
                            </svg>
                        )}
                        {!expanded && (
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
                                ></path>
                            </svg>
                        )}
                    </div>
                </div>
            )}

            {(!isMobile || (isMobile && expanded)) && (
                <div className={styles.expanded}>
                    <div className={styles.filtersSection}>
                        <h4 className={styles.filterHeading}>By theme and sub-theme:</h4>
                        <SelectTheme
                            themes={themes}
                            themeFilterState={themeFilterState}
                            subThemeFilterState={subThemeFilterState}
                            handleSubThemeFilter={handleSubThemeFilter}
                            handleThemeFilter={handleThemeFilter}
                        />
                    </div>

                    <div className={styles.filtersSection}>
                        <h4 className={styles.filterHeading}>and, by topic and keyword:</h4>
                        <div className={styles.filtersContainer}>
                            <div className={styles.filtersItem}>
                                <FilterDropdown
                                    options={searchOptions.filter(d => d.type === "topic")}
                                    placeholder="Type or select a topic..."
                                    handleFilter={handleTopicFilter}
                                    filterState={topicFilterState}
                                />
                            </div>
                            <div className={styles.filtersItem}>
                                <FilterDropdown
                                    options={searchOptions.filter(d => d.type === "keyword")}
                                    placeholder="Type or select a keyword..."
                                    handleFilter={handleKeywordFilter}
                                    filterState={keywordFilterState}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.filtersSection}>
                        <h4 className={styles.filterHeading}>and, by project-level opportunity search:</h4>
                        <input
                            name="searchOpportunities"
                            type="text"
                            value={opportunitySearch}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            className={styles.searchOpportunities}
                            placeholder="Enter some text to search opportunities"
                            aria-label="Search for opportunities input box"
                        />
                        <input
                            className={styles.searchOpportunitiesButton}
                            type="button"
                            value="Search"
                            onClick={handleOpportunitySearch}
                            disabled={opportunitySearch.length === 0 ? true : false}
                        />
                        <input
                            className={styles.clearSearch}
                            type="button"
                            value="Clear"
                            onClick={handleOpportunitySearchReset}
                            disabled={opportunitySearch.length === 0 ? true : false}
                        />
                    </div>

                    {isMobile && (
                        <div className={styles.applyContainer}>
                            <button className={styles.filtersReset} onClick={() => handleReset()}>
                                Reset filters and search
                            </button>
                            <button className={styles.filtersApply} onClick={() => handleApply()}>
                                Apply
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
